import { inject, Injectable } from '@angular/core';
import { HttpService } from '@utils/services/http.service';
import { UrlService } from '@utils/services/url-service.service';
import { Region } from '@app/utils/interfaces/Regions';
import { ApiModuleEnum } from '@utils/interfaces/api-module.constant';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  private readonly _http = inject(HttpService);
  private readonly _urlService = inject(UrlService);
  private readonly URL = this._urlService.getEndpointUrl(
    { module: ApiModuleEnum.BASE, version: 'v1', path: 'country' });

  public countries: Region[] = [];
  private _countriesSubject$ = new BehaviorSubject<Region[]>([]);
  public countries$ = this._countriesSubject$.asObservable();

  public getCountries(): void {
    this._http.GET<Region[]>({ url: this.URL }).subscribe({
      next: (cities) => {
        this.countries = cities;
        this._countriesSubject$.next(cities);
      }
    });
  }
}
